import React from 'react'

import Button from 'Components/Button'
import { SVGArrow, SVGFalse, SVGTick } from 'Components/SVGCollection'

import cn from 'classnames'
import cg from 'Scss/app.scss'
import cl from './Calendar.scss'
import btn from 'Components/Button/Button.scss'
import uniqWith from 'lodash/uniqWith'

import { ShippingMethodFragment_ShippingMethodGRoby_data, ShippingMethodFragment_ShippingMethodGRoby_data_timeRange, TimetableTimeSlotStatusType } from 'Utils/api/gql/types'
import { numberFormatter } from 'Utils/helpers/formatters'
import { connect } from 'react-redux'
import { getISODay, getISOWeek, parse, setISOWeek, isBefore, format, isSameYear, isSameMonth, isSameDay, isWithinRange, startOfISOWeek, lastDayOfISOWeek, setISODay } from 'date-fns'
import hu from 'date-fns/locale/hu'
import Logger from 'Utils/Logging'

type StateType = {
  displayedWeek: number
  selectedWeekDay: number | null
}

type PropType = {
  timeTableEntries: ShippingMethodFragment_ShippingMethodGRoby_data[]
  selectedSlotId: string | null
  onChange: (selectedSlot: string | null) => void
  isMobile: boolean
}

interface GrobyDay {
  date: Date
  slots: ShippingMethodFragment_ShippingMethodGRoby_data[]
}

// TODO: Aria
class Calendar extends React.Component<PropType, StateType> {
  constructor(props: PropType) {
    super(props)

    this.state = this.getInitialState();
  }

  componentDidMount() {
    this.validateTimeslot()
  }
  
  componentDidUpdate(prevProps: PropType) {
    if (this.props.timeTableEntries !== prevProps.timeTableEntries || this.props.selectedSlotId !== prevProps.selectedSlotId) {
      this.validateTimeslot()
      this.setState(this.getInitialState())
    }
  }
  
  getInitialState = () => {
    const initialDate = this.getInitialDate();

    const initialWeekDay = getISODay(initialDate)
    const initialWeek = getISOWeek(initialDate)

    return {
      displayedWeek: initialWeek,
      selectedWeekDay: initialWeekDay
    }
  }
  
  getInitialDate = () => {
    const selectedSlot = this.props.timeTableEntries.find(entry => entry.id === this.props.selectedSlotId)
    let initialDate: Date
    if (selectedSlot) {
      initialDate = parse(selectedSlot.range_date)
    } else {
      const sortedTimetableEntries = this.props.timeTableEntries
        .filter(entry => isBefore(new Date(), entry.visible_until))
        .sort((a, b) => isBefore(a.range_date, b.range_date) ? -1 : 1)
      const soonestTimetableEntry = sortedTimetableEntries[0]
      if (soonestTimetableEntry) {
        initialDate = parse(soonestTimetableEntry.range_date)
      } else {
        initialDate = new Date()
      }
    }
    
    return initialDate;
  }
  
  validateTimeslot = () => {
    if (!this.props.timeTableEntries.length || !this.props.selectedSlotId) return
    
    const found = this.props.timeTableEntries.find(tte => tte.id === this.props.selectedSlotId)
    if (!found) {
      this.props.onChange(null)
    }
  }
  
  displayedWeek = () => setISOWeek(this.getInitialDate(), this.state.displayedWeek)

  renderControls = () => {
    const week = this.displayedWeek()
    const weekStart = startOfISOWeek(week)
    const weekEnd = lastDayOfISOWeek(week)

    const prevDisabled = isBefore(weekStart, new Date())
    const startDate = format(weekStart, 'YYYY. MMMM D.', { locale: hu })

    let endDateFormat = ''
    if (!isSameYear(weekStart, weekEnd)) {
      endDateFormat += 'YYYY. '
    }
    if (!isSameMonth(weekStart, weekEnd)) {
      endDateFormat += 'MMMM '
    }
    endDateFormat += 'D.'

    const endDate = format(weekEnd, endDateFormat, { locale: hu })

    return (
      <div className={cn(cg.gridX, cg.alignMiddle, cl.checkoutCalendar__controls)}>
        <div className={cn(cg.cell, cg.shrink)}>
          <Button
            disabled={prevDisabled}
            className={cn(btn.blank)}
            renderIcon={{
              ariaLabel: 'Előző hét',
              Icon: <SVGArrow width="32" height="32" style={{ transform: 'rotate(180deg)' }} />
            }}
            onClick={() => { this.setState(state => ({ displayedWeek: state.displayedWeek - 1 })) }}
          />
        </div>

        <div className={cn(cg.cell, cg.auto, cl.checkoutCalendar__controlsHeader)}>
          <span>{startDate} - {endDate}</span>
        </div>

        <div className={cn(cg.cell, cg.shrink)}>
          <Button
            disabled={false}
            className={cn(btn.blank)}
            renderIcon={{
              ariaLabel: 'Következő hét',
              Icon: <SVGArrow width="32" height="32" />
            }}
            onClick={() => { this.setState(state => ({ displayedWeek: state.displayedWeek + 1 })) }}
          />
        </div>
      </div>
    )
  }

  get isMobile() {
      return typeof window === 'undefined'
        ? this.props.isMobile
        : window.matchMedia('(max-width: 1024px)').matches
  }

  selectDayFactory = (day: number) => () => {
    this.setState({ selectedWeekDay: day })
  }

  renderDay = (day: GrobyDay, timeRanges: ShippingMethodFragment_ShippingMethodGRoby_data_timeRange[], isSelectedSlotInWeek: boolean) => {
    const weekDay = getISODay(day.date)
    const isToday = isSameDay(day.date, new Date())

    const isSelectedSlotInDay = day.slots.some(slot => slot.id === this.props.selectedSlotId)
    const isDaySelected = this.isMobile
      ? weekDay === (this.state.selectedWeekDay || 1)
      : isSelectedSlotInDay

    const isEnabled = day.slots.some(slot => slot.status === TimetableTimeSlotStatusType.ACTIVE)
  return (
  <div key={`checkout-calendar-day__${weekDay}${this.state.displayedWeek}`} className={cn(cg.cell, cg.auto, cl.checkoutCalendar__day, isToday ? cl.checkoutCalendar__dayIsToday : {}, isDaySelected ? cl.checkoutCalendar__dayIsSelected : {}, weekDay === 7 ? cl.checkoutCalendar__dayLastCell : {})}>
    <div className={cg.showForSr}>
      {format(day.date, 'dddd', { locale: hu })}
    </div>

    <div className={cn(cg.hideForSr, cl.checkoutCalendar__dayName)}>
    {format(day.date, 'ddd', { locale: hu })}
    </div>

    <div className={cl.checkoutCalendar__dayButtonWrapper}>
      <button className={cn(cl.checkoutCalendar__dayButton, { [cl.buttonHighlighted]: isSelectedSlotInDay })} disabled={!isEnabled} onClick={this.selectDayFactory(weekDay)}>
      {format(day.date, 'DD', { locale: hu })}
      </button>
    </div>

    <div className={cl.checkoutCalendar__dayOptionsContainer}>
      {timeRanges.map((timeRange, i) => {
        const slot = day.slots.find(slot => slot.timeRange.id === timeRange.id)
        const slotIsSelected = slot && slot.id === this.props.selectedSlotId
        return !slot
          ? <div key={`checkout-calendar-day-option__${timeRange.id}`} className={cn(cg.gridX, cg.alignMiddle, cg.alignCenter, cl.checkoutCalendar__notAvailableGridX, cl.checkoutCalendar__dayOptionLabel)}>
            <span className={cn(cg.gridX, cg.alignMiddle, cl.checkoutCalendar__dayOptionLabelGridX)}>
              <span className={cg.showForSr}>
                {/* TODO: screen reader szöveg? */}
                A szállítás ebben az időpontban nem elérhető.
              </span>
              <span className={cn(cg.cell, cg.auto, cl.checkoutCalendar__dayOptionLabelOpeningHours, cl.checkoutCalendar__dayOptionLabelOpeningHoursIsInvisibleForDesktop)}>
                {timeRange.time_from} - {timeRange.time_to}
              </span>

              <span className={cn(cg.cell, cg.shrink)} aria-hidden={true}>
                <span className={cn(cg.gridX, cg.alignMiddle)}>
                  <span className={cn(cg.cell, cg.shrink)} aria-hidden={true}>
                    <SVGFalse width={24} height={24} />
                  </span>
                </span>
              </span>
            </span>
          </div>
          : <label key={`checkout-calendar-day-option__${timeRange.id}`} className={cl.checkoutCalendar__dayOptionLabel}>
            <input
              type="radio"
              name="checkout-calendar-day-option"
              className={cg.showForSr}
              checked={slotIsSelected}
              onChange={() => { this.props.onChange(slot.id); this.setState({ selectedWeekDay: weekDay })}}
            />

            <span className={cn(cg.gridX, cg.alignMiddle, cl.checkoutCalendar__dayOptionLabelGridX)}>
              <span className={cn(cg.cell, cg.auto, cl.checkoutCalendar__dayOptionLabelOpeningHours, cl.checkoutCalendar__dayOptionLabelOpeningHoursIsInvisibleForDesktop)}>
                {timeRange.time_from} - {timeRange.time_to}
              </span>

              <span className={cn(cg.cell, cg.shrink, cl.checkoutCalendar__dayOptionLabelPrice)}>
                <span className={cn(cg.gridX, cg.alignMiddle)}>
                  <span className={cn(cg.cell, cg.shrink)} aria-hidden={true}>
                    <SVGTick width={20} height={20} />
                  </span>
                  <span className={cn(cg.cell, cg.shrink)}>
                    {numberFormatter(slot.price)} Ft
                  </span>
                </span>
              </span>
            </span>
          </label>
      })}
    </div>
  </div>)
  }

  renderDays = () => {
    const timeTableEntries = this.props.timeTableEntries.filter(entry => isBefore(new Date(), entry.visible_until))
    const timeRanges =
      uniqWith(
        timeTableEntries.map(entry => entry.timeRange),
        (a,b) => a.id === b.id
      )
      .sort((a, b) => parseInt(a.time_from) - parseInt(b.time_from))

    const selectedSlot = this.props.timeTableEntries.find(slot => slot.id === this.props.selectedSlotId)
    const isSelectedSlotInWeek = selectedSlot
        ? isWithinRange(selectedSlot.range_date, startOfISOWeek(this.displayedWeek()), lastDayOfISOWeek(this.displayedWeek()))
        : false

    const days = [...Array(7)].map<GrobyDay>((_, i) => {
      const currentDay = setISODay(this.displayedWeek(), i + 1)
      const currentSlots = timeTableEntries.filter(entry => isSameDay(entry.range_date, currentDay))
      return {
        date: currentDay,
        slots: currentSlots
      }
    })

    return (
      <div className={cn(cg.gridX, cl.checkoutCalendar__days)}>
        <div className={cn(cg.cell, cg.shrink, cg.showForLarge, cl.checkoutCalendar__dayOptionsForDesktop)} aria-hidden={true}>
          <div className={cl.checkoutCalendar__dayOptionsContainer}>
            {timeRanges.map((timeRange, i) => (
              <div key={`checkout-calendar-day-option__show-for-large-${i}`} className={cl.checkoutCalendar__dayOptionLabel}>
                <div className={cn(cg.gridX, cg.alignMiddle, cl.checkoutCalendar__dayOptionLabelGridX)}>
                  <div className={cn(cg.cell, cl.checkoutCalendar__dayOptionLabelOpeningHours)}>
                    {timeRange.time_from} - {timeRange.time_to}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {days.map((day, i) => this.renderDay(day, timeRanges, isSelectedSlotInWeek))}
      </div>
    )
  }

  render() {
    if (!this.props.timeTableEntries.length) {
      return <i>Sajnos jelenleg egy szállítási időpont sem elérhető! Kérünk, válassz ki egy másik kiszállítási módot!</i>
    }
    
    return (
      <div className={cl.checkoutCalendar}>
        {this.renderControls()}
        {this.renderDays()}
      </div>
    )
  }
}

export default connect(({ isMobile }: Redux.IReduxState) => ({
  isMobile
}))(Calendar)
